import { EqButton, EqTypography } from "@equitable/equx";
import { Grid } from "@mui/material";
import { UnsubscribeTranslationValues } from "../types";
import checkmark from "../assets/check-checkmark-ok.svg";
import { useEffect, useState } from "react";
import { emailUtils } from "../utils/emailUtils";
import { useSearchParams } from "react-router-dom";
import { subscriberServices } from "../services/subscriberServices";
import { useNavigate } from "react-router-dom";
import { tokenServices } from "../services/tokenServices";

type UnsubscribeProps = {
  translations: UnsubscribeTranslationValues;
  lang: string;
};

const Unsubscribe = ({ translations, lang }: UnsubscribeProps) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState<boolean>(false);
  const [token, setToken] = useState<string | null>(null);

  useEffect(() => {
    const fetchToken = async () => {
      const res = await tokenServices.getToken();
      setToken(res.data.requestToken);
    };

    fetchToken();
  }, []);

  useEffect(() => {
    const deactivateSubscriber = async (emailEncoded: string) => {
      const EmailAddress = emailUtils.decodeEmail(emailEncoded);
      if (token) {
        subscriberServices.deactivateSubscriber({ EmailAddress }, token);
      }
    };

    const emailEncoded = searchParams.get("email");
    if (emailEncoded) {
      deactivateSubscriber(emailEncoded);
    }
  }, [searchParams, token]);

  const handleResubscribe = async () => {
    if (!token) return;
    const firstName = searchParams.get("firstName");
    const lastName = searchParams.get("lastName");
    const email = searchParams.get("email");

    if (email) {
      const subscriberData = {
        FirstName: firstName || "",
        LastName: lastName || "",
        EmailAddress: email,
        UserLanguage: lang.toUpperCase(),
      };

      setLoading(true);
      const res = await subscriberServices.addSubscriber(subscriberData, token);
      setLoading(false);

      if (res.status === 200) {
        if (lang === "en") {
          navigate("/en/success");
        } else {
          navigate("/fr/reussi");
        }
        return;
      }
    }
  };

  return (
    <Grid
      item
      sx={{
        backgroundColor: "#fff",
        margin: "48px 0",
        width: "582px",
        borderRadius: "24px",
        padding: "48px",
        boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.16)",
      }}
    >
      <Grid container rowSpacing={4} sx={{ margin: 0 }}>
        <Grid container justifyContent="center">
          <img
            src={checkmark}
            alt="checkmark"
            width="157"
            height="157"
            style={{ margin: "inherit" }}
          />
        </Grid>
        <Grid item xs={12}>
          <EqTypography variant="h3" sx={{ textAlign: "center" }}>
            {translations.unsubMsg}
          </EqTypography>
        </Grid>
        <Grid item xs={12}>
          <EqTypography
            variant="h6"
            sx={{ textAlign: "center", whiteSpace: "pre-line" }}
          >
            {translations.thankYou}
          </EqTypography>
        </Grid>
        <Grid item xs={12}>
          <EqButton
            variant="contained"
            label={translations.buttonLabel}
            color="surfacePrimaryDark"
            sx={{ width: "100%", padding: "16px", height: "48px" }}
            onClick={handleResubscribe}
            loading={loading}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Unsubscribe;
